import { DurationPeriod } from '@vendasta/sales-orders';

export interface ContractDurationTranslationKey {
  key: string;
  value: number;
}

export const ContractDurationKeysToEnum: ContractDurationTranslationKey[] = [
  { key: 'FRONTEND.SALES_UI.DAYS_PLURAL_OR_SINGULAR_LABEL', value: DurationPeriod.DAY },
  { key: 'FRONTEND.SALES_UI.WEEKS_PLURAL_OR_SINGULAR_LABEL', value: DurationPeriod.WEEK },
  { key: 'FRONTEND.SALES_UI.MONTHS_PLURAL_OR_SINGULAR_LABEL', value: DurationPeriod.MONTH },
  { key: 'FRONTEND.SALES_UI.YEARS_PLURAL_OR_SINGULAR_LABEL', value: DurationPeriod.YEAR },
];

export const ContractDurationEnumToKeys: string[] = [];
ContractDurationEnumToKeys['DAY'] = 'FRONTEND.SALES_UI.DAYS_PLURAL_OR_SINGULAR_LABEL';
ContractDurationEnumToKeys['WEEK'] = 'FRONTEND.SALES_UI.WEEKS_PLURAL_OR_SINGULAR_LABEL';
ContractDurationEnumToKeys['MONTH'] = 'FRONTEND.SALES_UI.MONTHS_PLURAL_OR_SINGULAR_LABEL';
ContractDurationEnumToKeys['YEAR'] = 'FRONTEND.SALES_UI.YEARS_PLURAL_OR_SINGULAR_LABEL';
